import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TARIFF_FEES_URL } from '../../shared/constants/urls';

@Injectable({
  providedIn: 'root'
})
export class TariffService {

  constructor(
    private readonly httpClient: HttpClient,
  ) { }

  getHeaders() {
    const headers = new HttpHeaders({
      'content-Type': 'application/json',
      authorization: 'bearer ' + localStorage.getItem('token')
    });
    return headers;
  }

  addTariffFees(newTariff) {
    return this.httpClient.post(TARIFF_FEES_URL, newTariff, {headers: this.getHeaders()});
  }

  editTariffFees(idTariff: string, body) {
    return this.httpClient.put(TARIFF_FEES_URL + idTariff, body, {headers: this.getHeaders()});
  }

  getTariff(id) {
    return this.httpClient.get(TARIFF_FEES_URL + 'enterprise/' + id , {headers: this.getHeaders()});
  }
}
